import request from '@/router/axios'

export function fetchAppConfigList(query) {
  return request({
    url: '/admin/admin/app-config/page',
    method: 'get',
    params: query
  })
}

export function createAppConfig(params) {
  return request({
    url: '/admin/admin/app-config/app',
    method: 'POST',
    data: params
  })
}

export function editAppConfig(params) {
  return request({
    url: '/admin/admin/app-config/app',
    method: 'PUT',
    data: params
  })
}

export function getAppConfigInfo(id) {
  return request({
    url: `/admin/admin/app-config/${id}`,
    method: 'get',
  })
}

export function removeAppConfig(id) {
  return request({
    url: `/admin/admin/app-config/${id}`,
    method: 'delete',
  })
}

export function updateConfigBanStatus(params) {
  return request({
    url: '/admin/admin/app-config/ban',
    method: 'PUT',
    data: params
  });
}


export function getAppGroupDrop() {
  return request({
    url: '/admin/admin/app-group/groups',
    method: 'get',
  })
}

export function createAppGroup(params) {
  return request({
    url: '/admin/admin/app-group/group',
    method: 'POST',
    data: params
  })
}

export function editAppGroup(params) {
  return request({
    url: `/admin/admin/app-group/group/${params.id}`,
    method: 'PUT',
    data: params
  })
}

export function getAppGroupInfo(id) {
  return request({
    url: `/admin/admin/app-group/group/${id}`,
    method: 'get',
  })
}

export function removeAppGroup(id) {
  return request({
    url: `/admin/admin/app-group/group/${id}`,
    method: 'delete',
  })
}

